import React from "react"
import compose from "recompose/compose"
import { routes } from "@/helpers/routes"
import {
  Header,
  InsightsLink,
  AppSwitcher,
  UserNav,
} from "@xingternal/rebranding-adapter"
import { withCurrentUser } from "@/helpers/hoc/withCurrentUser"
import { withi18n } from "@/helpers/hoc/withi18n"
import { withUser } from "@/components/UserContext"
import { withPermissions } from "@/helpers/hoc/withPermissions"
import { withTracking } from "@/helpers/hoc/withTracking"
import { withFeatureFlags } from "@/helpers/hoc/withFeatureFlags"

const i18n = {
  stopImpersonating: "360_STOP_IMPERSONATING",
  yourSettings: "XER_SETTINGS",
  help: "360_HELP",
}

const NavigationHeader = ({
  currentUser,
  isImpersonated,
  lng,
  onLogout,
  permissions,
  trackAction,
  onStopImpersonating,
  enabledFeatures,
  ...i18ns
}) => {
  const helpUrl = lng === "en" ? routes.helpEN : routes.help
  const onXJMClick = (e) => {
    e.preventDefault()
    const jobmanagerUrl =
      "https://onlyfy.io/?nwt_nav=job_manager&sc_o=xri_app_switcher_to_xjm_click"
    open(jobmanagerUrl, "_blank")
  }

  return (
    <Header
      currentApp="xri"
      lang={lng}
      data-testid="app-header"
      trackingUrlParam="xri_app_switcher_to_{app}_click"
      trackingExternalOnClick={(trackingId) => {
        trackAction(trackingId, {
          PropClientId: permissions.clients
            .map(({ id }) => `xri_${id}`)
            .join(";"),
        })
      }}
      zIndex="basicLevel"
    >
      <InsightsLink />
      <AppSwitcher.Container>
        <AppSwitcher.Title />
        <AppSwitcher.XTM />
        <AppSwitcher.XTP />
        <AppSwitcher.XJM onClick={onXJMClick} />
        <AppSwitcher.XBM />
        <AppSwitcher.Separator />
        <AppSwitcher.Prescreen />
        <AppSwitcher.HalloFreelancer />
        <AppSwitcher.Separator />
        <AppSwitcher.GoToXing />
      </AppSwitcher.Container>
      <AppSwitcher />
      <UserNav
        name={currentUser.fullName}
        avatarUrl={currentUser.avatarUrl}
        company={currentUser.company.name}
        mail={currentUser.email}
      >
        <UserNav.Item href={routes.yourSettings}>
          {i18ns.yourSettings}
        </UserNav.Item>
        <UserNav.Item href={helpUrl}>{i18ns.help}</UserNav.Item>

        <UserNav.Item onClick={onStopImpersonating}>
          {i18ns.stopImpersonating}
        </UserNav.Item>
        {isImpersonated ? (
          <UserNav.Item onClick={onStopImpersonating}>
            {i18ns.stopImpersonating}
          </UserNav.Item>
        ) : (
          <UserNav.Logout onClick={onLogout} />
        )}
      </UserNav>
    </Header>
  )
}

const enhance = compose(
  withi18n(i18n),
  withUser,
  withCurrentUser,
  withPermissions,
  withTracking(),
  withFeatureFlags,
)

export default enhance(NavigationHeader)
